/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const submissionUpdateState = {
  USER_REFERENCE_SET: 'USER_REFERENCE_SET',
  USER_REFERENCE_UNSET: 'USER_REFERENCE_UNSET',
};

export const initialDraftState = {
  draftUpdateState: null,
  progress: false,
  submissionUpdateState: null,
  configuration: {
    validationSchema: null,
    uiSchema: null,
  },
};

export const draftActions = {
  SEND_TO_SIGN: 'SEND_TO_SIGN',
  CALCULATE_WORKFLOW_PROGRESS_START: 'CALCULATE_WORKFLOW_PROGRESS_START',
  CALCULATE_WORKFLOW_PROGRESS_END: 'CALCULATE_WORKFLOW_PROGRESS_END',
  CALCULATE_WORKFLOW_POSTPROCESS_START: 'CALCULATE_WORKFLOW_POSTPROCESS_START',
  CALCULATE_WORKFLOW_POSTPROCESS_END: 'CALCULATE_WORKFLOW_POSTPROCESS_END',
  UPDATE_ATTACHMENTS: 'UPDATE_ATTACHMENTS',
  USER_REFERENCE_SET: 'USER_REFERENCE_SET',
  USER_REFERENCE_UNSET: 'USER_REFERENCE_UNSET',
  CONFIGURATION: 'CONFIGURATION',
  CONFIGURATION_ERROR: 'CONFIGURATION_ERROR',
  CONFIGURATION_DEFAULT_VERSION: 'CONFIGURATION_DEFAULT_VERSION',
};

export const reducer = (state, { type, value }) => {
  switch (type) {
    case draftActions.CALCULATE_WORKFLOW_PROGRESS_START:
      return { ...state, progress: true };
    case draftActions.CALCULATE_WORKFLOW_PROGRESS_END:
      return { ...state, progress: false };
    case draftActions.CALCULATE_WORKFLOW_POSTPROCESS_START:
      return { ...state, postProcess: true };
    case draftActions.CALCULATE_WORKFLOW_POSTPROCESS_END:
      return { ...state, postProcess: false };
    case draftActions.USER_REFERENCE_SET: {
      return { ...state, submissionUpdateState: submissionUpdateState.USER_REFERENCE_SET };
    }
    case draftActions.USER_REFERENCE_UNSET: {
      return { ...state, submissionUpdateState: null };
    }
    case draftActions.CONFIGURATION_DEFAULT_VERSION:
      return { ...state, configuration: { ...state.configuration, version: value } };
    case draftActions.CONFIGURATION:
      return { ...state, configuration: { ...state.configuration, [value.type]: value.value } };
    default: {
      return state;
    }
  }
};
